import React from 'react';

import QuotaVendedor  from 'components/Tvendo/Sale/QuotaBPartner/Clorox/QuotaVendedorClorox/List.js';

export default function () {
  return <QuotaVendedor  />;
}